// utils/dateUtils.js
export const toDate = (val) => {
  if (!val) return null;
  if (val?.toDate) return val.toDate();               // Firestore Timestamp
  if (typeof val === "string") {
    // "YYYY-MM-DD" → local date, not UTC-shifted
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(val);
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    // fallback for ISO strings
    const d = new Date(val);
    return isNaN(d.getTime()) ? null : d;
  }
  if (val instanceof Date) return val;
  return null;
};

export const isSameLocalDay = (a, b) =>
  a &&
  b &&
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const parseLocalTimeToMinutes = (hhmmOr12h) => {
  if (!hhmmOr12h) return 24 * 60; // push undefined times to end
  // handles "14:30", "2:30 PM", "2 PM"
  const m24 = /^(\d{1,2}):(\d{2})$/.exec(hhmmOr12h);
  if (m24) return Number(m24[1]) * 60 + Number(m24[2]);
  const m12 = /^(\d{1,2})(?::(\d{2}))?\s*(AM|PM)$/i.exec(hhmmOr12h);
  if (m12) {
    let h = Number(m12[1]) % 12;
    const mins = Number(m12[2] || 0);
    if (m12[3].toUpperCase() === "PM") h += 12;
    return h * 60 + mins;
  }
  return 24 * 60;
};
